import type { HostConfig } from '../host'
import { ocamHost } from './ocam'

/**
 * Every host this build serves.
 *
 * One, now. The white-label era is over: `me.o-kb.com`, `cam.o-kb.com` and
 * `cam.console.openside.com` each wore a tenant's brand and published to that
 * tenant's API, chosen by hostname. Everyone moved to o-cam.app, where a
 * destination is installed at runtime with a code instead.
 *
 * Adding a host is still a code change on purpose: the same commit adds its
 * config and its custom domain to wrangler.jsonc, so a deployment cannot exist
 * without a config or a config without a deployment.
 */
export const HOSTS: readonly HostConfig[] = [ocamHost]

export { ocamHost }
